module.exports = __webpack_public_path__ + "assets/img/home-img2.ea972a29.png";